module.exports = __webpack_public_path__ + "img/ctrl-p-stub-mid--i.6ca49494.svg";